module.exports = __webpack_public_path__ + "Octopus.f2a1ed8843d0529624e529729e047096.hashedasset.svg";